import { not } from '@feedyou/utils'
import { BotId } from '@feedyou/schema'

import { FeedbotThunk } from '../../store/types'
import { nlpTrainingApi } from './nlpTrainingApi'
import {
  RowDbDescriptor,
  NlpLogDbPartitionDescriptor
} from '../../components/nlp/TrainingTab/types'

export function removeAllUnprocessedNlpRowsFromCache(params: {
  botId: BotId
  partition: NlpLogDbPartitionDescriptor
}): FeedbotThunk {
  return dispatch =>
    dispatch(
      nlpTrainingApi.util.updateQueryData('getUnprocessedNlpRows', params, draft => (draft = []))
    )
}

export function removeUnprocessedNlpRowsFromCache(params: {
  botId: BotId
  query: string
  rowsToDelete: RowDbDescriptor[]
  partition: NlpLogDbPartitionDescriptor
}): FeedbotThunk {
  return dispatch => {
    const { botId, query, partition, rowsToDelete } = params
    dispatch(
      nlpTrainingApi.util.updateQueryData('getUnprocessedNlpRows', { botId, partition }, draft => {
        const index = draft.findIndex(logGroup => logGroup.query === query)
        const newRowDescriptors = draft[index].dbRowDescriptors.filter(
          not(isRowIncludedInGivenDbRowDescriptors(rowsToDelete))
        )

        if (!newRowDescriptors.length) {
          draft.splice(index, 1)
          return
        }

        draft[index].dbRowDescriptors = newRowDescriptors
        draft[index].groupingLog = newRowDescriptors.map(descriptor => ({
          dbDescriptor: descriptor
        }))
      })
    )
  }
}

function isRowIncludedInGivenDbRowDescriptors(rowDecriptors: RowDbDescriptor[]) {
  return ({ rowKey, partitionKey }: RowDbDescriptor): boolean =>
    !!rowDecriptors.find(r => rowKey === r.rowKey && partitionKey === r.partitionKey)
}
